import gql from 'graphql-tag';

const NAME = 'inventoryOutput';
const FRAGMENT = `
  fragment ${NAME} on MoveIqInventoryOutput {
    inventoryItems {
      cubesheetItem {
        id
        name
        category
        weight
      }
      homeArea
      id
      quantity
      weight
    }
    moveId
    totalItems
    totalWeight
  }`;

export default {
  fragment: FRAGMENT,
  name: NAME,
  gql: gql`
    ${FRAGMENT}
  `,
};
